export default "__VITE_ASSET__2zvouZvd__"